export const CategoriasActionTypes = {
  API_RESPONSE_SUCCESS: '@@categorias/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@categorias/API_RESPONSE_ERROR',

  GET_CATEGORIA: '@@categorias/GET_CATEGORIA',
  LIST_CATEGORIAS: '@@categorias/LIST_CATEGORIAS',
  ADD_CATEGORIA: '@@categorias/ADD_CATEGORIA',
  UPDATE_CATEGORIA: '@@categorias/UPDATE_CATEGORIA',
  DELETE_CATEGORIA: '@@categorias/DELETE_CATEGORIA',

  RESET: '@@categorias/RESET'
}
